import { http } from '../utils/http'

// 查询
const searchAction = (params, page, size) => {
    const url = `/config/formulaType/page`
    return http.post(url, params, page, size)
};

// 新增 / 修改
const addAction = (params) => {
    const url = `/config/formulaType/save`
    return http.post(url, params)
};

// 删除
const delAction = (id) => {
    const url = `/config/formulaType/delete/${id}`
    return http.post(url)
};

// 获取单条数据
const getAction = (id) => {
    const url = `/config/formulaType/get/${id}`
    return http.post(url)
};

export default {
    searchAction,
    addAction,
    delAction,
    getAction
  }